import React from "react";
import { cellGrow } from "constants/styles";
import Pill from "components/Pill";
import classnames from "classnames";
import { UI_THEME } from "utils/constants/ui";
import { COLORS } from "utils/styles";
import { gridContainer } from "constants/styles";

const FEATURES = {
  CHECKOUT: "checkout",
  BACKEND: "backend",
  PRICES: "prices",
  AUTOMATE: "automate"
};

const DOCS_GRID_CONFIG = [
  {
    id: FEATURES.CHECKOUT,
    label: "One click checkout",
    description:
      "Let your customers checkout directly from your Webflow site, in one click."
  },
  {
    id: FEATURES.BACKEND,
    label: "No coding",
    description:
      "You don't have to write any special backend code. Just add a link to your page to start accepting payments."
  },
  {
    id: FEATURES.PRICES,
    label: "Customize payments",
    description:
      "Add prices, discounts, trials, tax rates and more to any of your payment links. You get total control over payment terms."
  },
  {
    id: FEATURES.AUTOMATE,
    label: "Connect your apps",
    description:
      "Connect your checkout, payments and subscription data to any of your other apps through Zapier and Integromat."
  }
];

const FeatureGrid = () => {
  return (
    <div className="w-100">
      <div className="grid-container-2xl pt3">
        {DOCS_GRID_CONFIG.map(
          ({ Icon, label, description, callout, footer }, gridIx) => {
            return (
              <div className="w-100 pb3 pb0-ns" key={gridIx}>
                <div className="flex flex-row justify-between items-center">
                  <div className="flex flex-row items-center w-100">
                    {Icon && <Icon size={20} color={COLORS.primary} />}
                    <div
                      className={classnames(
                        "f4 f3-l fw6 color-text--primary lh-title",
                        {
                          pl2: Icon
                        }
                      )}
                      style={{ marginTop: 2 }}
                    >
                      {label}
                    </div>
                  </div>
                  {callout && <Pill copy={callout} theme={UI_THEME.SLIM} />}
                </div>
                <div className="f5 f4-l lh-copy pt2 mt1 color-text--primary">
                  {description}
                </div>
                {footer}
              </div>
            );
          }
        )}
        <style jsx>{gridContainer}</style>
        <style jsx>{cellGrow}</style>
      </div>
    </div>
  );
};

export default FeatureGrid;
